import React from 'react';
import { FormattedMessage } from 'translations';
import { Layout } from 'app/components/base/Layout';
import Icon from 'app/components/base/Icon';

import style from './style.css';

const messages = {
  instantConfrmation: { id: 'BOOK_TRIP.INSTANT_CONFIRMATION' }
};

const InstantConfrmation = () => {
  return (
    <Layout className={style.container} align="start center" nowrap>
      <div className={style.icon}>
        <Icon family="mozio" small>sb-check</Icon>
      </div>
      <span className={style.text}>
        <FormattedMessage {...messages.instantConfrmation} />
      </span>
    </Layout>
  );
};

export default InstantConfrmation;
